import { createRequestActionTypes } from "../../../utility";

export const OrderFavoritesDropdownActionTypes = {
  get_orderFavorites: createRequestActionTypes('GET_ORDER_FAVORITES'),
}